// Length constants for validation
export const LENGTH_XXS = 16;
export const LENGTH_XS = 32;
export const MAX_DIALOG_NAME_LENGTH = 45;
export const LENGTH_S = 64;
export const LENGTH_M = 128;
export const LENGTH_L = 256;
export const LENGTH_XL = 512;
export const LENGTH_XXL = 1000;
export const LENGTH_1024 = 1024;
export const LENGTH_2048 = 2048;
export const LENGTH_XXXL = 4096;
export const LENGTH_10000 = 10000;
export const LIVE_INSTRUCTIONS_LIMIT = 32768;
export const TAG_LENGTH = 48;

// WhatsApp Flow character limits based on Meta's API documentation
export const WHATSAPP_FLOW_LIMITS = {
  CTA: 20,
  BODY: 1024,
  HEADER: 60,
  FOOTER: 60,
  SCREEN: 128,
} as const;

export const QUESTION_SET_LIMITS = {
  TITLE: 120,
  QUESTIONS: 5,
  KEY: 40,
  HEADER: 24,
  QUESTION: 120,
  OPTIONS_MIN: 2,
  OPTIONS_MAX: 6,
  LABEL: 48,
  VALUE: 48,
  DESCRIPTION: 90,
} as const;

// WhatsApp Cloud API limits the `display_text` of CTA URL and webview buttons
// to 20 characters; longer labels fail at send time with error #131009.
export const WHATSAPP_BUTTON_TEXT_LIMIT = 20;

// 160 is WhatsApp's native carousel limit; Messenger and Instagram cut at 80, Zendesk at 128.
export const CAROUSEL_SUBTITLE_MAX_LENGTH = 160;
export const CAROUSEL_SUBTITLE_META_LIMIT = 80;
export const CAROUSEL_SUBTITLE_ZENDESK_LIMIT = 128;

export const MAX_SIP_HEADERS = 20;

// Handover options
export const HANDOVER_OPTIONS = {
  DEFAULT: 'default',
  ZENDESK_DEPARTMENT_ROUTING: 'zendesk_department_routing',
  FACEBOOK_MESSENGER_HANDOVER: 'facebook_messenger_handover',
  VOICE_HANDOVER: 'voice_handover',
} as const;

// Voice handover transport: how the call is transferred during voice handover.
export const VOICE_HANDOVER_TRANSPORT = { DIAL: 'dial', REFER: 'refer' } as const;

// Condition rule operators that require a value
export const requireValueInRule = [
  'equal',
  'not_equal',
  'greater',
  'less',
  'contain',
  'not_contain',
];

// Required field validation constant
export const isRequired = { required: { value: true, message: 'This is a required field' } };
